module.exports = __webpack_public_path__ + "static/media/magic.c9b24a87.mp3";